module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("ASHTON")]), _vm._v(" "), _c('p', {
    staticClass: "CIT"
  }, [_vm._v("Why couldn’t I have just made it home without seeing them? I wasn’t in the mood to play good freaking Samaritan to Beau and his trashy girlfriend. Although he wasn’t here, Sawyer would expect me to stop. With a frustrated groan, I slowed down and pulled up beside Beau, who had put some distance between him and his vomiting girlfriend. Apparently, throw up wasn’t a mating call for him. “Where’s your truck parked, Beau?” I asked in the most annoyed tone I could muster. He flashed me that stupid sexy grin that he knew made every female in town melt at his feet. I’d like to believe I was immune after all these years, but I wasn’t. Being immune to the town’s bad boy was impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t tell me perfect little Ashton Gray is gonna offer to "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("help me out,” he drawled, leaning down to stare at me through my open window.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sawyer’s out of town, so the privilege falls to me. He wouldn’t let you drive home drunk and neither will I.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He chuckled sending a shiver of pleasure down my spine. God. He even "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("laughed")]), _vm._v(" sexy. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thanks, beautiful, but I can handle this. Once Nic stops puking, I’ll throw her in my truck. I can drive the three miles to her house. You run on along now. Don’t you have a bible study somewhere you should be at?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Arguing with him was pointless. He would just start throwing out more snide comments until he had me so mad I couldn’t see straight. I pressed the gas and turned into the parking lot. Like I was going to be able to just leave and let him drive home drunk. He could infuriate me with a wink of his eye, and I worked real hard at being nice to everyone. I scanned the parked cars for his old, black Chevy truck. Once I spotted it, I walked over to him and held out my hand. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Either you can give me the keys to your truck or I can go digging for them. What’s it going to be, Beau? You want me searching your pockets?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A crooked grin touched his face. “As a matter of fact, I think I might just enjoy you digging around in my pockets, Ash. Why don’t we go with option number two?”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Heat rose up my neck and left splotches of color on my ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("cheeks. I didn’t need a mirror to know I was blushing like an idiot. Beau never made suggestive comments to me or even flirted with me. I happened to be the only reasonably attractive female at school he completely ignored.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t you dare touch him, you stupid bitch. His keys are in the ignition of his truck.” Nicole, Beau’s on-again-off-again girlfriend, lifted her head, slinging her dark brown hair back over her shoulder, and snarled at me. Bloodshot blue eyes filled with hate watched me as if daring me to touch what was hers. I didn’t respond to her nor did I look back up at Beau. Instead I turned and headed for his truck, reminding myself I was doing this for Sawyer. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Come on then and get in the truck,” I barked at both of them before sliding into the driver’s seat. It was really hard not to focus on the fact this was the first time I’d ever been in Beau’s truck. After countless nights of lying on my roof with him, talking about the day we’d get our driver’s licenses and all the places we would go, I was just now, at seventeen years old, sitting inside his truck. Beau picked Nicole up and dumped her in the back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Lie down unless you get sick again. Then make sure you puke over the side,” he snapped while opening the driver’s side door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hop out, princess. She’s about to pass out; she won’t care if I’m driving.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I gripped the steering wheel tighter.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("“I’m not going to let you drive. You’re slurring your words. You don’t need to drive.”")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("He opened his mouth to argue then mumbled something that sounded like a curse word before slamming the door and walking around the front of the truck to get in on the passenger’s side. He didn’t say anything, and I didn’t glance over at him. Without Sawyer around, Beau made me nervous.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m tired of arguing with females tonight. That’s the only reason I’m letting you drive,” he grumbled, without a slur this time. It wasn’t surprising that he could control the slurring. The boy had been getting drunk before most the kids our age had tasted their first beer. When a guy had a face like Beau’s, older girls took notice. He’d been snagging invites to the field parties way before the rest of us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I managed a shrug. “You wouldn’t have to argue with me if you didn’t drink so much.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He let out a hard laugh. “You really are a perfect little preacher’s daughter, aren’t you, Ash? Once upon a time you were a helluva lot more fun. Before you started sucking face with Sawyer, we use to have some good times together.” He was watching me for a reaction. Knowing his eyes were directed at me made it hard to focus on driving. “You were my partner in crime, Ash. Sawyer was the good guy. But the two of us, we were the troublemakers. What happened?”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("How do I respond to that?")]), _vm._v(" No one knows the girl who used to ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("steal bubble gum from the Quick Stop or abduct the paperboy to tie him up so we could take all his papers and dip them in blue paint before leaving them on the front door steps of houses. No one knew the girl who snuck out of her house at two in the morning to go toilet-paper yards and throw water balloons at cars from behind the bushes. No one would even believe I’d done all those things if I told them. . . . No one but Beau.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“I grew up,” I finally replied.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You completely changed, Ash.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We were kids, Beau. Yes, you and I got into trouble, and Sawyer got us out of trouble, but we were just kids. I’m different now.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For a moment he didn’t respond. He shifted in his seat, and I knew his gaze was no longer focused on me. We’d never had this conversation before. Even if it was uncomfortable, I knew it was way overdue. Sawyer always stood in the way of Beau and me mending our fences, fences that had crumbled, and I never knew why. One day he was Beau, my best friend. The next day he was just my boyfriend’s cousin. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I miss that girl, you know. She was exciting. She knew how to have fun. This perfect little preacher’s daughter who took her place sucks.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("His words hurt. Maybe because they were coming from him or maybe because I understood what he was saying. It wasn’t as if I never thought about that girl. I hated him for making me ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("miss her too. I worked really hard at keeping her locked away. Having someone actually want her to be set loose made it so much harder to keep her under control.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’d rather be a preacher’s daughter than a drunk whore who vomits all over herself,” I snapped before I could stop myself. A low chuckle startled me, and I glanced over as Beau sunk down low enough in his seat so his head rested on the worn leather instead of the hard window behind him. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I guess you’re not completely perfect. Sawyer’d never call someone a name. Does he know you use the word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("whore")]), _vm._v("?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This time I gripped the steering wheel so tightly my knuckles turned white. He was trying to make me mad and he was doing a fabulous job. I had no response to his question. The truth was, Sawyer would be shocked that I’d called someone a whore. Especially his cousin’s girlfriend. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Loosen up, Ash, it’s not like I’m gonna tell on you. I’ve been keeping your secrets for years. I like knowing my Ash is still there somewhere underneath that perfect facade.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I refused to look at him. This conversation was going somewhere I didn’t want it to go. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No one is perfect. I don’t pretend to be,” I said, which was a lie and we both knew it. Sawyer was perfect, and I worked hard to be worthy. The whole town knew I fell short of his glowing reputation. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Beau let out a short, hard laugh. “Yes, Ash, you do pretend to be.” ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("I pulled into Nicole’s driveway. Beau didn’t move. ")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“She’s passed out. You’re going to have to help her,” I whispered, afraid he’d hear the hurt in my voice. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You want me to help a vomiting whore?” he asked with an amused tone. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sighed and finally glanced over at him. He reminded me of a fallen angel as the moonlight casted a glow on his sun-kissed blond hair. His eyelids were heavier than usual, and his thick eyelashes almost concealed the hazel color of his eyes underneath. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“She’s your girlfriend. Help her.” I managed to sound angry. When I let myself study Beau this closely, it was hard to get disgusted with him. I could still see the little boy I’d once thought hung the moon, staring back at me. Our past would always be there, keeping us from ever really being close again. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thanks for reminding me,” he said, reaching for the door handle without breaking his eye contact with me. I dropped my gaze to study my hands, which were now folded in my lap. Nicole fumbled around in the back of the truck, causing it to shake gently and reminding us that she was back there. After a few more silent moments, he finally opened the door.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Beau carried Nicole’s limp body to the door and knocked. It opened and he walked inside. I wondered who opened the door. Was it Nicole’s mom? Did she care her daughter was passed out drunk? Was she letting Beau take her up to her room? Would Beau stay with her? Crawl in bed with her and ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("fall asleep? Beau reappeared in the doorway before my imagination got too carried away. ")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Once he was back inside the truck, I cranked it up and headed for the trailer park where he lived. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So tell me, Ash, is your insistence to drive the drunk guy and his whore girlfriend home because you’re the perpetual good girl who helps everyone? ’Cause I know you don’t like me much, so I’m curious as to why you want to make sure I get home safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Beau, you’re my friend. Of course I like you. We’ve been friends since we were five. Sure we don’t hang out anymore or go terrorizing the neighborhood together, but I still care about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Since when?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Since when what?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Since when do you care about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That is a stupid question, Beau. You know I’ve always cared about you,” I replied. Even though I knew he wouldn’t let such a vague answer fly. The truth was that I never really talked to him much anymore. Nicole was normally wrapped around one of his body parts. And when he spoke to me, it was always to make some wisecrack. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You hardly acknowledge my existence,” he replied. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s not true.” ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("He chuckled. “We sat by each other in history all year, and you hardly ever glanced my way. At lunch you never look at me, ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("and I sit at the same table you do. We’re at the field parties every weekend, and if you ever turn your superior gaze in my direction, it’s normally with a disgusted expression. So I’m a little shocked you still consider me a friend.”")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The large live oak trees signaled the turn into the trailer park where Beau had lived all is life. The sight of the rich beauty of the southern landscape as you pulled onto the gravel road was deceiving. Once I drove passed the large trees, the scenery drastically changed. Weathered trailers with old cars were up on blocks, and battered toys scattered the yards. More than one window was covered with wood or plastic. I didn’t gawk at my surroundings. Even the man sitting on his porch steps with a cigarette hanging out of his mouth and wearing nothing but his underwear didn’t surprise me. I knew this trailer park well. It was a part of my childhood. I came to a stop in front of Beau’s trailer. It would be easier to believe that this was the alcohol talking, but I knew it wasn’t. We hadn’t been alone in over four years. Since the moment I became Sawyer’s girlfriend, our relationship had changed. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I took a deep breath, then turned to look at Beau. “I never talk in class. Not to anyone but the teacher. You never talk to me at lunch, so I have no reason to look your way. Attracting your attention leads to you making fun of me. And, at the field, I’m not looking at you with disgust. I’m looking at Nicole with disgust. You could really do much better than her.” I stopped myself before I said anything stupid. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("He tilted his head to the side as if studying me. “You don’t like Nicole much, do you? You don’t have to worry about her hang-up with Sawyer. He knows what he’s got, and he isn’t going to mess it up. Nicole can’t compete with you.”")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Nicole had a thing for Sawyer? She was normally mauling Beau. I’d never picked up on her liking Sawyer. I knew they’d been an item in seventh grade for, like, a couple of weeks, but that was junior high school. It didn’t really count. Besides, she was with Beau. Why would she be interested in anyone else?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I didn’t know she liked Sawyer,” I replied, still not sure I believed him. Sawyer was so not her type. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You sound surprised,” Beau replied. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, I am, actually. I mean, she has you. Why does she want Sawyer?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A pleased smile touched his lips making his hazel eyes light up. I realized I hadn’t exactly meant to say something that he could misconstrue in the way he was obviously doing. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He reached for the door handle before pausing and glancing back at me. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I didn’t know my teasing bothered you, Ash. I’ll stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That hadn’t been what I was expecting him to say. Unable to think of a response, I sat there holding his gaze. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("“I’ll get your car switched back before your parents see my truck at your house in the morning.” He stepped out of the truck, and I watched him walk toward the door of his trailer ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("with one of the sexiest swaggers known to man. Beau and I had needed to have that talk, even if my imagination was going to go wild for a while, where he was concerned. My secret attraction to the town’s bad boy had to remain a secret.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The next morning, I found my car parked in the driveway, as promised, with a note wedged under the windshield wipers. I reached for it, and a small smile touched my lips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thanks for last night. I’ve missed you.” He had simply signed it “B.”")])]), _c('p', {
    staticClass: "CN"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5415ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 75
// module chunks = 0